<template lang="pug">
  div.structure-header
    ods-icon.ods-actions-menu__button(@click.native="showCalendar" class="ods-icon-calendar-change" name="calendar" size="18")
    ods-icon.ods-actions-menu__button(@click.native="showHelp" class="header-tools__icon" name="help" size="18")
    //- ods-icon.ods-actions-menu__button(name="setting" size="18")
    Calendar(id='calendar' v-if='calendarVisible' @closeCalendar='closeCalendar')
    ods-dialog(
      :visible.sync="helpVisible"
      width='95%'
      :append-to-body="true"
      custom-class="sc-modal"
    )
      div(class="sc-modal__title") {{ $t('¿Necesitas ayuda?') }}
      p(class="sc-modal__description") {{ $t('Puedes contactar con el equipo de soporte técnico SmartCities de las siguientes maneras:') }}
      div(class="sc-modal__info")
        div(class="sc-modal__label") {{ $t('teléfono') }}
        div(class="sc-modal__number") 9177628212
      div(class="sc-modal__info")
        div(class="sc-modal__label") {{ $t('correo') }}
        div(class="sc-modal__email") soporte@smartcities.com
</template>

<script>
import Calendar from '@/components/Calendar'
export default {
  name: 'HeaderCustomContent',
  data () {
    return {
      helpVisible: false,
      calendarVisible: false
    }
  },
  components: {
    Calendar
  },
  methods: {
    showHelp () {
      this.helpVisible = true
    },

    showCalendar () {
      this.calendarVisible = true
    },
    closeCalendar () {
      const component = this
      setTimeout(function () {
        component.calendarVisible = false
        // console.log('cerrado Fin' + component.calendarVisible)
      }, 400)
      // console.log('cerrado' + component.calendarVisible)
    }
  }
}
</script>

<style lang="scss" scoped>
.structure-header {
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}

@media only screen and (max-width: 1023px) {
  .structure-header {
    flex-wrap: wrap;
  }
}

.ods-icon-calendar-change{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/header/HeaderCustomContent.vue